import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withHashLocation,
  withInMemoryScrolling,
} from '@angular/router';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { APP_ROUTES } from './app.routes';
import { APP_ENVIRONMENT } from './core/constants/injection-tokens';
import { SmoothScrollService } from './core/services/smooth-scroll.service';
import { SHOPIFY_CONFIG } from './core/shopify/config/shopify.tokens';
import { createShopifyConfig } from './core/shopify/config/shopify-config.model';
import { environment } from '../environments/environment';
import { errorInterceptor, shopifyTokenInterceptor } from './core/interceptors/http.interceptors';

const routerFeatures = [
  // Emit Scroll events; SmoothScrollService owns the actual smooth scrolling.
  withInMemoryScrolling({
    scrollPositionRestoration: 'disabled',
    anchorScrolling: 'disabled',
  }),
  withComponentInputBinding(),
  // Hash only for Hostinger static deploy — never with ng serve / SSR (causes redirect loop).
  ...(environment.useHashRouting ? [withHashLocation()] : []),
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(APP_ROUTES, ...routerFeatures),
    provideAppInitializer(() => {
      inject(SmoothScrollService).start();
    }),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptors([shopifyTokenInterceptor, errorInterceptor])),
    { provide: APP_ENVIRONMENT, useValue: environment },
    {
      provide: SHOPIFY_CONFIG,
      useFactory: () =>
        createShopifyConfig({
          SHOPIFY_STORE_DOMAIN: environment.SHOPIFY_STORE_DOMAIN,
          SHOPIFY_STOREFRONT_TOKEN: environment.SHOPIFY_STOREFRONT_TOKEN,
          SHOPIFY_API_VERSION: environment.SHOPIFY_API_VERSION,
        }),
    },
  ],
};
